import { HTMLAttributes } from "react";
import { twMerge } from 'tailwind-merge'

interface SubTitleProps extends HTMLAttributes<HTMLSpanElement> {
    text?: string
}

export function SubTitle({ text, ...rest }: SubTitleProps) {
    return (
        <span {...rest} className={twMerge("tw-text-xl tw-font-semibold tw-text-[#565656]", rest.className)}>
            {text}
        </span>
    )
}